import { createFileRoute } from '@tanstack/react-router';
import { VehicleDetail } from '@/features/fuel/VehicleDetail';

export const Route = createFileRoute('/_shell/fuel/vehicles/$vehicleId')({
  component: VehicleDetailRoute,
});

function VehicleDetailRoute() {
  const { vehicleId } = Route.useParams();
  return <VehicleDetail vehicleId={vehicleId} />;
}
